import { listUnusedStepTemplates } from '../utils';
function deleteUnusedStepTemplates(source, stepTemplates = []) {
    var _a;
    const unusedStepTemplates = listUnusedStepTemplates(source);
    const stepTemplatesToDelete = stepTemplates.length ?
        unusedStepTemplates.filter(unusedTemplate => stepTemplates.find(template => unusedTemplate.id === template.id)) :
        unusedStepTemplates;
    const stepTemplatesInSource = ((_a = source === null || source === void 0 ? void 0 : source.data) === null || _a === void 0 ? void 0 : _a.stepTemplates) || [];
    return Object.assign(Object.assign({}, source), { data: Object.assign(Object.assign({}, source.data), { stepTemplates: stepTemplatesInSource.filter(template => !stepTemplatesToDelete.find(unusedTemplate => unusedTemplate.id === template.id)) }) });
}
export default deleteUnusedStepTemplates;
//# sourceMappingURL=deleteUnusedStepTemplates.js.map